import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";

import { ContentBlock } from "@/libraries/design/components";
import { wacToken } from "@/libraries/design/foundations";

export type TwcPromoProducts = "jira" | "confluence" | "loom";

type TwcPromoProps = {
    product: TwcPromoProducts;
};

export const TwcPromo = ({ product }: TwcPromoProps) => {
    const intl = useIntl();

    let text = intl.formatMessage({
        id: "TeamworkCollection.promo.jira.body",
        defaultMessage:
            "Get Jira, Confluence, Loom, and Rovo in one collection to bring together projects, knowledge, video communication, and AI-powered insights."
    });
    if (product === "confluence") {
        text = intl.formatMessage({
            id: "TeamworkCollection.promo.confluence.body",
            defaultMessage:
                "Get Confluence, Jira, Loom, and Rovo in one collection to bring together knowledge, projects, video communication, and AI-powered insights."
        });
    }
    if (product === "loom") {
        text = intl.formatMessage({
            id: "TeamworkCollection.promo.loom.body",
            defaultMessage:
                "Get Loom, Jira, Confluence, and Rovo in one collection to bring together video communication, projects, knowledge, and AI-powered insights."
        });
    }

    return (
        <section
            css={css({
                width: "100vw",
                marginBlock: token("space.400")
            })}
        >
            <ContentBlock
                logo="teamworkCollection"
                title={intl.formatMessage({
                    id: "TeamworkCollection.promo.title",
                    defaultMessage: "All your tools, one collection"
                })}
                text={text}
                callToActionProps={{
                    link: {
                        text: intl.formatMessage({
                            id: "TeamworkCollection.promo.body",
                            defaultMessage: "Explore Teamwork Collection"
                        }),
                        href: "/collections/teamwork"
                    }
                }}
                pictureProps={{
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6n7524uo343a2x8y0x03jmpvu54e4km7.png",
                        alt: ""
                    }
                }}
                orientation="horizontal-reverse"
                columns={12}
                backgroundColor={`${wacToken("color.extended.blue200")}`}
                hat="high-right"
            />
        </section>
    );
};
